import { Button, color, InputSelect } from "@funded-here-interface/common";
import { useMemo, useState } from "react";
import useGetExchangeRate from "../../../hooks/useGetExchangeRate";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { toast } from "react-toastify";
import { GetExchangeRateResponse } from "../../../services/getExchangeRate";
import useGetCurrencyList from "../../../hooks/useGetCurrencyList";

const ExchangeRate = () => {
  const token = useSelector((state: RootState) => state.auth.token);

  const { data: currencyList } = useGetCurrencyList(token);
  const [currency1, setCurrency1] = useState<string>("");
  const [currency2, setCurrency2] = useState<string>("");
  const [currencyData, setCurrencyData] = useState<string[]>([]);

  const [error, setError] = useState({
    currency1: "",
    currency2: "",
  });
  const [exchangeRate, setExchangeRate] =
    useState<GetExchangeRateResponse | null>(null);

  const useGetExchangeRateMutation = useGetExchangeRate();

  useMemo(() => {
    if (currencyList) {
      setCurrencyData(Object.keys(currencyList));
    }
  }, [currencyList]);

  const handleSubmit = () => {
    let errors = {
      currency1: "",
      currency2: "",
    };

    if (!currency1) {
      errors.currency1 = "Currency 1 is required";
    }

    if (!currency2) {
      errors.currency2 = "Currency 2 is required";
    }

    if (currency1 && currency2) {
      const currency1Value = currencyList?.[currency1];
      const currency2Value = currencyList?.[currency2];

      toast.info("Fetching exchange rate...");
      useGetExchangeRateMutation.mutate(
        {
          token,
          currency1: currency1Value,
          currency2: currency2Value,
        },
        {
          onSuccess: (data) => {
            setExchangeRate(data);
            toast.success("Exchange rate fetched successfully!");
          },
          onError: (error) => {
            let error_msg = (error as Error).message;
            error_msg = error_msg.replace(
              "Error when calling wallex makeRequest: ",
              ""
            );
            error_msg = error_msg.split(", config")[0];

            let errorCode = JSON.parse(error_msg);
            errorCode = errorCode?.error_code;
            toast.error(`Error when calling Wallex Api: ${errorCode}`);
          },
        }
      );
    }

    setError(errors);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <div style={{ width: "50%" }}>
          <InputSelect
            isErrored={error.currency1}
            labelText="Currency 1"
            data={currencyData}
            value={currency1}
            onChange={(value: string) => {
              setCurrency1(value);
            }}
          ></InputSelect>
        </div>

        <div style={{ width: "50%" }}>
          <InputSelect
            isErrored={error.currency2}
            labelText="Currency 2"
            data={currencyData}
            value={currency2}
            onChange={(value: string) => {
              setCurrency2(value);
            }}
          ></InputSelect>
        </div>
      </div>

      <div style={{ marginTop: "1rem" }}>
        <Button
          onClick={handleSubmit}
          textColor={color.WHITE}
          backgroundColor={color.FHGREEN}
        >
          Convert Exchange Rate
        </Button>
      </div>

      <div style={{ marginTop: "2rem" }}>
        <table
          style={{
            border: "1px solid black",
            width: "100%",
            height: "300px",
            textAlign: "center",
          }}
        >
          <tr style={{ border: "3px solid black" }}>
            <th
              style={{
                border: "3px solid black",
                width: "40%",
                background: "#8db1e6",
              }}
            >
              Normal
            </th>
            <th style={{ width: "20%" }}></th>
            <th
              style={{
                border: "3px solid black",
                width: "40%",
                background: "#ccc8ca",
              }}
            >
              Inverse
            </th>
          </tr>
          <tr style={{ border: "1px solid black" }}>
            <th style={{ border: "1px solid black", width: "40%" }}>
              {exchangeRate?.currencyPair}
            </th>
            <th style={{ width: "20%" }}>Currency Pair</th>
            <th style={{ border: "1px solid black", width: "40%" }}>
              {exchangeRate?.inverse?.currencyPair}
            </th>
          </tr>
          <tr style={{ border: "1px solid black" }}>
            <th style={{ border: "1px solid black", width: "40%" }}>
              {exchangeRate?.bid}
            </th>
            <th style={{ width: "20%" }}>BID</th>
            <th style={{ border: "1px solid black", width: "40%" }}>
              {exchangeRate?.inverse?.bid}
            </th>
          </tr>
          <tr style={{ border: "1px solid black" }}>
            <th style={{ border: "1px solid black", width: "40%" }}>
              {exchangeRate?.ask}
            </th>
            <th style={{ width: "20%" }}>ASK</th>
            <th style={{ border: "1px solid black", width: "40%" }}>
              {exchangeRate?.inverse?.ask}
            </th>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default ExchangeRate;
